import { FC } from 'react';
import { clsx } from 'clsx';

import { IHeaderTeacherTableRowTableHeader } from '../models/types';

import styles from './styles.module.scss';

export const HeaderTeacherRowTableSchedule: FC<
  IHeaderTeacherTableRowTableHeader
> = ({ isScrolled }) => {
  return (
    <div
      className={clsx(styles['table-schedule-row'], {
        [styles['table-schedule-row_scrolled']]: isScrolled,
      })}
    >
      <div className={styles['table-schedule-cell']}>
        <div className={styles['table-schedule__time-interval']}>
          Дата и время
        </div>
      </div>
      <div className={styles['table-schedule-cell']}>
        <div className={styles['table-schedule__discipl-type']}>
          Тип занятия
        </div>
      </div>
      <div className={styles['table-schedule-cell']}>Дисциплина</div>
      <div className={styles['table-schedule-cell']}>Аудитория и здание</div>
      <div className={styles['table-schedule-cell']}>
        <div
          className={clsx(
            styles['table-schedule__teacher'],
            clsx(styles['table-schedule__teacher_clean']),
          )}
        >
          Преподаватель
        </div>
      </div>
    </div>
  );
};
